/**
 * What "the gameweek deadline" means, for both halves of the app.
 *
 * Lives in `src/` rather than `server/` because the server imports across that boundary freely
 * (`applyAutoPredict`, `teams`, `types`) and the client cannot import the other way. One module,
 * one number, one function — the header countdown and the server-side lock must reach the same
 * instant, and two copies of "30 minutes" is a bug waiting for the first time someone changes one.
 */

/** Predictions close this long before the gameweek's first kickoff. */
export const DEADLINE_LEAD_MS = 30 * 60_000

/**
 * The gameweek's deadline from its kickoffs, or null when it has none.
 *
 * Callers pass only the kickoffs that count: a voided fixture is excluded upstream, because a
 * postponed lunchtime kickoff must not pull the whole gameweek's deadline forward.
 */
export function deadlineFromKickoffs(kickoffMs: number[]): number | null {
  if (kickoffMs.length === 0) return null
  return Math.min(...kickoffMs) - DEADLINE_LEAD_MS
}
